import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { CommandCenterConfiguration, CommandCenterMenuConfiguration } from 'src/app/shared/models/CommandCenterConfiguration';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { UserRoleEnum } from 'src/app/shared/models/enums/user-role.enum';

@Component({
	selector: 'app-menu-setup',
	templateUrl: './menu-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class MenuSetupComponent implements OnInit {
	ccMenu: CommandCenterConfiguration;

	childCategories: CommandCenterMenuConfiguration[];

	fontAwesomePrefix = [
		{
			label: 'Solid (fas)',
			value: 'fas',
		},
		{
			label: 'Regular (far)',
			value: 'far',
		},
		{
			label: 'Light (fal)',
			value: 'fal',
		},
		{
			label: 'Duotone (fad)',
			value: 'fad',
		},
		{
			label: 'Brands (fab)',
			value: 'fab',
		},
	];

	menuTreeFormat;

	menuVersion: number;

	parentCategories: CommandCenterMenuConfiguration[];

	selectedMenu = new CommandCenterMenuConfiguration();

	userRole: { label: string; value: number }[] = [];

	constructor(public app: AppService, private focuslink: FocuslinkService, private menuService: MenuService) {}

	ngOnInit(): void {
		this.load();
		Object.keys(UserRoleEnum).forEach((key) => {
			if (isNaN(+key)) {
				this.userRole.push({
					label: key,
					value: UserRoleEnum[key],
				});
			}
		});

		this.menuVersion = 1;
	}

	async changeMenuType(event) {
		this.app.loading(true);
		await this.getMenuConfiguration(+event.value);
		this.app.loading(false);
	}

	load() {
		this.getMenuConfiguration(1);
	}

	async getMenuConfiguration(menuVersion: number) {
		const resp = await this.focuslink.adminCommandCenterConfigurationGet(1);
		const menuReturn = new CommandCenterConfiguration(resp);
		this.ccMenu = menuReturn;

		this.buildMenu([...this.ccMenu.menu]);

		return menuReturn.menu;
	}

	buildMenu(menu: CommandCenterMenuConfiguration[]) {
		const menuFormat = this.menuService.buildMenu(menu, true);
		this.parentCategories = [
			{
				label: '--New Parent--',
				key: undefined,
				sortOrder: 99,
				itemUserLevel: 1,
				faIcon: undefined,
				faIconPrefix: undefined,
				routerLink: undefined,
				itemUserPermission: undefined,
				parentKey: undefined,
			},
		];

		this.parentCategories = this.parentCategories.concat(
			menuFormat
				.filter((m) => m.items)
				.map((m) => {
					return new CommandCenterMenuConfiguration(m);
				})
		);

		this.menuTreeFormat = menuFormat.map((tier1) => {
			return {
				label: tier1.label,
				data: menu.find((menuRecord) => menuRecord.key === tier1.key),
				children: tier1.items.map((tier2) => {
					return {
						label: tier2.label,
						data: menu.find((menuRecord) => menuRecord.key === tier2.key),
						children: tier2.items?.map((tier3) => {
							return {
								label: tier3.label,
								data: menu.find((menuRecord) => menuRecord.key === tier3.key),
							};
						}),
					};
				}),
			};
		});
	}

	deleteMenuSection() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete this menu section? This cannot be undone and Brandon might get 😡`,
			accept: async () => {
				this.focuslink.adminCommandCenterConfigurationDelete(this.selectedMenu.key);
				setTimeout(() => {
					this.getMenuConfiguration(this.menuVersion);
					this.menuService.loadMenuFromApi();
				}, 500);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	newMenuSection() {
		this.selectedMenu = new CommandCenterMenuConfiguration();
	}

	saveMenuChanges() {
		this.app.confirmation.confirm({
			message: `Are you sure you want to save this menu section change?`,
			accept: async () => {
				if (!Array.isArray(this.selectedMenu.routerLink)) {
					const rl = this.selectedMenu.routerLink;
					if (!this.selectedMenu.parentKey) {
						this.selectedMenu.routerLink = undefined;
					} else {
						this.selectedMenu.routerLink = [rl];
					}
				}
				this.focuslink.adminCommandCenterConfigurationPut(this.selectedMenu);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `${this.selectedMenu.label} saved successfully.` });
				this.selectedMenu = new CommandCenterMenuConfiguration();
				setTimeout(() => {
					this.getMenuConfiguration(this.menuVersion);
					this.menuService.loadMenuFromApi();
				}, 500);
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}

	selectExistingMenu(event) {
		let menuNode;
		if (!event.node.data) {
			menuNode = this.ccMenu.menu.find((m) => m.label === event.node.label);
		} else {
			menuNode = this.ccMenu.menu.find((m) => m.key === event.node.data.key);
		}
		this.selectedMenu = menuNode;
	}
}

interface menuModel {
	key?: string;
	parentKey?: string;
	separator?: boolean;
	label?: string;
	faIcon?: string;
	faIconPrefix?: string;
	icon?: string;
	sortOrder?: number;
	itemUserLevel?: number;

	routerLink?: string[];
	items?: menuModel[];
}
[];
